<template>
  <div>
    <b-modal
      :title="(isEditPri ? 'Edit ' : duplicatePri ? 'Duplicate ' : 'Create ') + ' Your Custom Predicative - '+(priTypes[form.setup.selectedPriType-1] && priTypes[form.setup.selectedPriType-1].text || '')"
      v-model="showAddPriModal"
      size="xl"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div>
        <b-tabs
          content-class="mt-3"
          v-if="!priSubmiting && !priResponseSuccess"
          small
          card
          fill
          lazy
        >
          <b-tab
            title="Setup"
            class="text-left"
            active
            style="height:calc(100vh - 300px); overflow-y:auto;"
          >
            <b-form-group label="Pri Title" description="Please enter a title for your PRI">
              <b-form-input
                type="text"
                :disabled="viewDisablePriModal"
                v-model="$v.form.setup.priTitle.$model"
                :state="$v.form.setup.priTitle.$dirty ? !$v.form.setup.priTitle.$error : null"
                @input="setPriTitleValue"
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group label="PRI Type">
              <b-form-radio-group
                :options="priTypes"
                v-model="$v.form.setup.selectedPriType.$model"
                :state="$v.form.setup.selectedPriType.$dirty ? !$v.form.setup.selectedPriType.$error : null"
                name="radio-pri"
              ></b-form-radio-group>
            </b-form-group>-->
            <b-form-group label="Select the required indicators" v-if="form.setup.priTitle">
              <!-- <b-form-checkbox
                v-if="!platformPriSettings"
                :disabled="viewDisablePriModal"
                @change="setSanctionsWeightingsInput"
                v-model="form.showSanctions"
              >Sanctions and Enforcement</b-form-checkbox>-->
              <b-form-checkbox
                v-if="platformPriSettings"
                :disabled="viewDisablePriModal"
                @change="setNegativeMediasWeightingsInput"
                v-model="form.showNegativeMedia"
              >Negative Media</b-form-checkbox>
              <div class="ml-5" v-if="form.showNegativeMedia && platformPriSettings">
                <b-form-group label="Categories">
                  <b-form-checkbox
                    inline
                    :disabled="viewDisablePriModal"
                    v-model="form.setup.negativeMedia.selectedCategories"
                    v-for="(priType,index) in dueDiligenceCategoriesOption"
                    :key="index"
                    :value="priType"
                    @input="setNegativeMediaCategoriesData"
                  >{{priType.text}}</b-form-checkbox>
                </b-form-group>
              </div>

              <b-form-checkbox
                @change="setCountryWeightingsInput"
                :disabled="viewDisablePriModal"
                v-if="!platformPriSettings"
                v-model="form.showCountry"
              >Country</b-form-checkbox>
              <b-form-checkbox
                @change="setIndustryWeightingsInput"
                :disabled="viewDisablePriModal"
                v-if="!platformPriSettings"
                v-model="form.showIndustry"
              >Industry</b-form-checkbox>
              <b-form-checkbox
                v-model="form.showCustomIndicators"
                :disabled="viewDisablePriModal"
                v-if="!platformPriSettings"
              >Custom Indicators</b-form-checkbox>
              <b-form-checkbox
                v-model="form.showFutureRisks"
                v-if="platformPriSettings"
                :disabled="viewDisablePriModal"
              >Future Risks</b-form-checkbox>
              <div class="ml-5" v-if="form.showFutureRisks && platformPriSettings">
                <b-form-group label="Categories">
                  <b-form-checkbox
                    inline
                    v-model="form.setup.futureRisks.selectedCategories"
                    :disabled="viewDisablePriModal"
                    v-for="(priType,index) in dueDiligenceCategoriesOption"
                    :key="index"
                    :value="priType"
                    @input="setFutureRisksCategoriesData"
                  >{{priType.text}}</b-form-checkbox>
                </b-form-group>
              </div>
              <b-form-checkbox
                v-model="form.showOpenCorporate"
                v-if="platformPriSettings"
                :disabled="viewDisablePriModal"
              >Open Corporate</b-form-checkbox>
              <b-form-checkbox
                v-model="form.showPublicListing"
                v-if="platformPriSettings"
                :disabled="viewDisablePriModal"
              >Public Listing</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab
            title="Weightings"
            v-if="form.showSanctions || form.showNegativeMedia || form.showCountry || form.showIndustry || form.showCustomIndicators"
          >
            <WeightingsComponent
              :showCustomIndicators="form.showCustomIndicators"
              :searchPage="viewDisablePriModal"
              :defaultIndicatorsData="defaultIndicators"
              :customIndicatorsData="customIndicators"
            />
            <!-- :sanctionsAndEnforcementDisable="sanctionsAndEnforcementDisable" -->
          </b-tab>
          <!-- <b-tab title="Sanctions & Enforcements" class="text-left" v-if="form.showSanctions">
            <SanctionsEnforcementsComponent :searchPage="viewDisablePriModal" />
          </b-tab>-->

          <!-- negatve MEDIA---------- -->
          <b-tab title="Negative Media" v-if="form.showNegativeMedia && platformPriSettings">
            <b-tabs small card fill>
              <b-tab title="Scoring">
                <NegativeMediaScoringTab :searchPage="viewDisablePriModal" />
              </b-tab>
              <b-tab title="Configration">
                <div class="ml-5">
                  <b-form-group label="Categories">
                    <b-form-checkbox
                      inline
                      :disabled="viewDisablePriModal"
                      v-model="form.setup.negativeMedia.selectedCategories"
                      v-for="(priType,index) in dueDiligenceCategoriesOption"
                      :key="index"
                      :value="priType"
                      @input="setNegativeMediaCategoriesData"
                    >{{priType.text}}</b-form-checkbox>
                  </b-form-group>
                </div>
              </b-tab>
              <b-tab
                :title="type.text"
                v-for="(type,index) in form.setup.negativeMedia.selectedCategories"
                :key="index"
              >
                <NegativeMediaComponent
                  :searchPage="viewDisablePriModal"
                  :priConfigrationKeywordsData="priConfigrationKeywordsData"
                  :priConfigrationExcludeKeywordsData="priConfigrationExcludeKeywordsData"
                  :priConfigrationStopWordsData="priConfigrationStopWordsData"
                  :negativeMediaEdit="negativeMediaEdit"
                  :tabIndex="index"
                />
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab title="Country" class="text-left" v-if="form.showCountry && !platformPriSettings">
            <CountryComponent :searchPage="viewDisablePriModal" />
          </b-tab>
          <b-tab
            title="Industry"
            class="text-left"
            v-if="form.showIndustry && !platformPriSettings"
          ></b-tab>
          <b-tab title="Custom Indicators" v-if="form.showCustomIndicators && !platformPriSettings">
            <CustomIndicatorsComponent
              :searchPage="viewDisablePriModal"
              :customIndicatorsData="customIndicators"
            />
          </b-tab>
          <b-tab title="Future Risks" v-if="form.showFutureRisks && platformPriSettings">
            <b-tabs small card fill>
              <b-tab title="Scoring">
                <FutureRisksScoringTab :searchPage="viewDisablePriModal" />
              </b-tab>
              <b-tab title="Configration">
                <div class="ml-5">
                  <b-form-group label="Categories">
                    <b-form-checkbox
                      inline
                      :disabled="viewDisablePriModal"
                      v-model="form.setup.futureRisks.selectedCategories"
                      v-for="(priType,index) in dueDiligenceCategoriesOption"
                      :key="index"
                      :value="priType"
                      @input="setFutureRisksCategoriesData"
                    >{{priType.text}}</b-form-checkbox>
                  </b-form-group>
                </div>
              </b-tab>
              <b-tab
                :title="type.text"
                v-for="(type,index) in form.setup.futureRisks.selectedCategories"
                :key="index"
              >
                <FutureRisksComponent
                  :priConfigrationKeywordsData="priConfigrationKeywordsData"
                  :priConfigrationExcludeKeywordsData="priConfigrationExcludeKeywordsData"
                  :priConfigrationStopWordsData="priConfigrationStopWordsData"
                  :futureRisksEdit="futureRisksEdit"
                  :searchPage="viewDisablePriModal"
                  :tabIndex="index"
                />
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab title="Open Corporate" v-if="form.showOpenCorporate && platformPriSettings">
            <OpenCorporateComponent :searchPage="viewDisablePriModal" />
          </b-tab>
          <b-tab title="Public Listing" v-if="form.showPublicListing && platformPriSettings">
            <PublicListingComponent :searchPage="viewDisablePriModal" />
          </b-tab>
        </b-tabs>
        <div v-else-if="priSubmiting && !priResponseSuccess">
          <p>{{ isEditPri ? 'Your Pri is being updating......' : duplicatePri ? 'Your Pri is being duplicating......' : 'Your Pri is being adding......' }}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ isEditPri ? 'Your Pri has been updated successfully.' : duplicatePri ? 'Your Pri has been Duplicated successfully.' : 'Your Pri has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" @click="resetForm">Close</b-button>
        <b-button
          :disabled="$store.state.priConfigrationforms.sanctions.validInputField"
          v-if="!priSubmiting && !priResponseSuccess && !viewDisablePriModal"
          variant="outline-success"
          @click="checkValidation"
        >{{ isEditPri ? 'Update' : duplicatePri ? 'Duplicate' : 'Create '}}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../../utils/HTTP";
import NegativeMediaComponent from "./negativeMedia.vue";
// import SanctionsEnforcementsComponent from "./sanctionsEnforcementsComponent.vue";
import CountryComponent from "./countryComponent.vue";
import CustomIndicatorsComponent from "./customIndicatorsComponent.vue";
import WeightingsComponent from "./weightingsComponent.vue";
import FutureRisksComponent from "./futureRisksComponent.vue";
import OpenCorporateComponent from "./openCorporateComponent.vue";
import PublicListingComponent from "./publicListingComponent.vue";
import NegativeMediaScoringTab from "./negativeMediaComponent/negativeMediaScoringTab.vue";
import FutureRisksScoringTab from "./futureRisksScoringTab.vue";
export default {
  name: "AddPriModal",
  mixins: [validationMixin],
  components: {
    NegativeMediaComponent,
    FutureRisksComponent,
    // SanctionsEnforcementsComponent,
    CountryComponent,
    CustomIndicatorsComponent,
    WeightingsComponent,
    OpenCorporateComponent,
    PublicListingComponent,
    NegativeMediaScoringTab,
    FutureRisksScoringTab,
  },
  data() {
    return {
      isEditPri: false,
      /**
       * Media Search
       */
      priTitle: null,
      form: {
        pri_category_id: 1,
        setup: {
          selectedPriType: null,
          priTitle: null,
          negativeMedia: {
            selectedCategories: [],
          },
          futureRisks: {
            selectedCategories: [],
          },
        },
        rules: {},
        showSanctions: false,
        showNegativeMedia: false,
        showCountry: false,
        showIndustry: false,
        showCustomIndicators: false,
        showFutureRisks: false,
        showOpenCorporate: false,
        showPublicListing: false,
        status: 1, //1=draft
      },

      priSubmiting: false,
      priResponseSuccess: false,
      showAddPriModal: false,
      isLoadingPriData: false,
      isLoading: false,
      priSimulationPage: false,
      /**
       * Pri categories
       */
      priTypes: [
        { text: "Anti-Corruption & Bribery", value: 1 },
        { text: "Human Rights", value: 2 },
        { text: "Animal Welfare", value: 3 },
        { text: "Data Privacy", value: 4 },
        { text: "Information Security", value: 5 },
      ],
      defaultIndicators: [],
      dueDiligenceCategoriesOption: [],
      /**
       * Custom Indicators
       */
      indicators: [],
      customIndicators: [],
      /**
       *
       */
      /**
       * Default indicators
       */
      // fo score
      leastValue: 1,
      mediumValue: 1,
      highestValue: 100,
      showScoreError: null,
      totalScore: null,
      //for custom indicators tab
      customIndicatorsTabs: [],
      selectedPriId: null,
      negativeMediaEdit: false,
      futureRisksEdit: false,
      editNegativeMediaData: [],
      editFutureRisksData: [],
      sanctionsAndEnforcementDisable: true,
      priConfigrationKeywordsData: [],
      priConfigrationExcludeKeywordsData: [],
      priConfigrationStopWordsData: [],
      duplicatePri: false,
      viewDisablePriModal: false,
    };
  },
  validations: {
    form: {
      // countryRules: {
      //   selectedCountryIndex: {
      //     required
      //   }
      // },
      setup: {
        // selectedPriType: {
        //   required
        // },
        priTitle: {
          required,
        },
      },
    },
  },
  mounted() {
    this.getClientPri();
    this.getAllPriData();
    if (this.clientPriSettings) {
      this.getClientCustomPriFields();
    } else {
      this.getAllCustomPriFields();
    }
    this.getDueDiligenceCategoriesOptions();
  },
  created() {
    EventBus.$on("onShowAddModal", () => {
      this.showAddModal();
    });
    EventBus.$on("onShowEditModal", (value) => {
      this.showEditModal(value);
    });
    EventBus.$on("onShowEditModalOnPriSimulationPage", (value, id) => {
      this.showEditModalOnPriSimulationPage(value, id);
    });
    EventBus.$on("onShowAddModalOnPriSimulationPage", (value) => {
      this.showAddModalOnPriSimulationPage(value);
    });
    EventBus.$on("onShowDuplicateModal", (value) => {
      this.showDuplicateModal(value);
    });
    EventBus.$on("onShowViewPriModal", (value) => {
      this.showViewPriModal(value);
    });
  },
  methods: {
    setNegativeMediaCategoriesData() {
      this.form.setup.negativeMedia.selectedCategories.map(() => {
        this.setNegativeMediaCategoriesValue();
      });
    },
    setFutureRisksCategoriesData() {
      this.form.setup.futureRisks.selectedCategories.map(() => {
        this.setFutureRisksCategoriesValue();
      });
    },
    setNegativeMediaCategoriesValue() {
      this.$store.state.priConfigrationforms.negativeMedia.categories.push({
        customGoogleSearchEngineSites: null,
        searchKeywords: [],
        searchKeywordsNlp: [],
        searchExcludeKeywords: [],
        stopWords: [],
        exactPhraseMatch: 1,
        sortResult: 1,
        numberOfResults: { value: 1, text: "10" },
        // google: 1,
        // bing: 1,
        language: { value: "lang_en", text: "English" },
        prePendSearchText: null,
        appendSearchText: null,
        ignoreArticlesOlderThen: null,
        ignoreArticlesWithoutDates: false,
        ignoreArticlesFromLocalSites: false,
        ignoreArticlesFromRegionalSites: false,
        ignoreArticlesFromGlobalSites: false,
        ignoreArticlesFromGlobalRegionalLocalSites: false,
        disableRemovalText: false,
        scoring: {
          weighting: {
            lowerUpperLimit: 30,
            mediumUpperLimit: 32,
            ageOfArticleWeightingValue: null,
            siteTypeWeightingValue: null,
            nlpMatchWeightingValue: null,
            keywordCountTotalWeightingValue: null,
          },
          ageOfArticleObject: {
            ageOfArticle: true,
            ageOfArticleToValue: [],
            ageOfArticleScoreValue: [],
          },
          siteTypeObject: {
            siteType: true,
            localSiteType: null,
            regionalSiteType: null,
            globalSiteType: null,
            unkownSiteType: null,
          },
          keywordCountObject: {
            keywordCountTotal: true,
            lowerUpperLimit: 30,
            mediumUpperLimit: 32,
          },
          nlpMatchObject: {
            nlpMatch: true,
            matchNlpValue: null,
          },
        },
      });
    },
    setFutureRisksCategoriesValue() {
      this.$store.state.priConfigrationforms.futureRisks.categories.push({
        customGoogleSearchEngineSites: null,
        searchKeywords: [],
        searchKeywordsNlp: [],
        searchExcludeKeywords: [],
        stopWords: [],
        exactPhraseMatch: 1,
        sortResult: 1,
        numberOfResults: { value: 1, text: "10" },
        // google: 1,
        // bing: 1,
        language: { value: "lang_en", text: "English" },
        lowerUpperLimit: 30,
        mediumUpperLimit: 32,
        prePendSearchText: null,
        appendSearchText: null,
      });
    },
    showAddModal() {
      this.showAddPriModal = true;
      this.isEditPri = false;
    },
    showViewPriModal(value) {
      this.editFutureRisksData = [];
      this.editNegativeMediaData = [];
      this.defaultIndicators = [];
      this.showAddPriModal = true;
      this.viewDisablePriModal = true;
      this.selectedPriId = value.item.id;
      let configuration = JSON.parse(value.item.configuration);
      this.defaultIndicators = configuration.weighting
        ? configuration.weighting.defaultIndicators
        : configuration.overallWeighting.defaultIndicators;
      this.form = configuration;
      this.$store.state.priConfigrationforms.sanctions =
        configuration.sanctions;
      this.$store.state.priConfigrationforms.countryRules =
        configuration.countryRules;
      this.$store.state.priConfigrationforms.customIndicationsSettings =
        configuration.customIndicationsSettings;
      this.$store.state.priConfigrationforms.overallWeighting = configuration.weighting
        ? configuration.weighting
        : configuration.overallWeighting;
      this.$store.state.priConfigrationforms.openCorporate =
        configuration.openCorporate;
      this.$store.state.priConfigrationforms.publicListings =
        configuration.publicListings;
      this.negativeMediaEdit = true;
      this.$store.state.priConfigrationforms.negativeMedia.categories = [];
      this.$store.state.priConfigrationforms.negativeMedia.scoring = configuration
        .negativeMedia.scoring
        ? configuration.negativeMedia.scoring
        : this.$store.state.priConfigrationforms.negativeMedia.scoring;
      this.$store.state.priConfigrationforms.futureRisks.scoring = configuration
        .futureRisks.scoring
        ? configuration.futureRisks.scoring
        : this.$store.state.priConfigrationforms.futureRisks.scoring;

      if (configuration.negativeMedia.categories.length > 0) {
        configuration.negativeMedia.categories.map((negativeMediaData) => {
          this.editNegativeMediaData.push(negativeMediaData.settings);
        });
        this.editNegativeMediaData.map((categoriesData) => {
          if (categoriesData.scoring == undefined) {
            this.$store.state.priConfigrationforms.negativeMedia.categories.push(
              {
                customGoogleSearchEngineSites:
                  categoriesData.customGoogleSearchEngineSites,
                searchKeywords: categoriesData.searchKeywords,
                searchKeywordsNlp: categoriesData.searchKeywordsNlp,
                searchExcludeKeywords: categoriesData.searchExcludeKeywords,
                stopWords: categoriesData.stopWords,
                exactPhraseMatch: categoriesData.exactPhraseMatch,
                sortResult: categoriesData.sortResult,
                numberOfResults: categoriesData.numberOfResults,
                language: categoriesData.language,
                prePendSearchText: categoriesData.prePendSearchText,
                appendSearchText: categoriesData.appendSearchText,
                ignoreArticlesOlderThen: categoriesData.ignoreArticlesOlderThen,
                ignoreArticlesWithoutDates:
                  categoriesData.ignoreArticlesWithoutDates,
                ignoreArticlesFromLocalSites:
                  categoriesData.ignoreArticlesFromLocalSites,
                ignoreArticlesFromRegionalSites:
                  categoriesData.ignoreArticlesFromRegionalSites,
                ignoreArticlesFromGlobalSites:
                  categoriesData.ignoreArticlesFromGlobalSites,
                ignoreArticlesFromGlobalRegionalLocalSites:
                  categoriesData.ignoreArticlesFromGlobalRegionalLocalSites,
                disableRemovalText: categoriesData.disableRemovalText,
                scoring: {
                  weighting: {
                    lowerUpperLimit: categoriesData.lowerUpperLimit,
                    mediumUpperLimit: categoriesData.mediumUpperLimit,
                    ageOfArticleWeightingValue:
                      categoriesData.ageOfArticleValue,
                    siteTypeWeightingValue: categoriesData.siteTypeValue,
                    nlpMatchWeightingValue: categoriesData.nlpMatchValue,
                    keywordCountTotalWeightingValue:
                      categoriesData.keywordCountTotalValue,
                  },
                  ageOfArticleObject: {
                    ageOfArticle: categoriesData.ageOfArticle,
                    ageOfArticleToValue: categoriesData.ageOfArticleToValue,
                    ageOfArticleScoreValue:
                      categoriesData.ageOfArticleScoreValue,
                  },
                  siteTypeObject: {
                    siteType: categoriesData.siteType,
                    localSiteType: categoriesData.localSiteType,
                    regionalSiteType: categoriesData.regionalSiteType,
                    globalSiteType: categoriesData.globalSiteType,
                    unkownSiteType: categoriesData.unkownSiteType,
                  },
                  keywordCountObject: {
                    keywordCountTotal: categoriesData.keywordCountTotal,
                    lowerUpperLimit: categoriesData.matchKeywordCountValue,
                    mediumUpperLimit: 0,
                  },
                  nlpMatchObject: {
                    nlpMatch: categoriesData.nlpMatch,
                    matchNlpValue: categoriesData.matchNlpValue,
                  },
                },
              }
            );
          } else {
            this.$store.state.priConfigrationforms.negativeMedia.categories.push(
              categoriesData
            );
          }
        });
      } else {
        this.priTypes.map(() => {
          this.setNegativeMediaCategoriesValue();
        });
      }

      this.futureRisksEdit = true;
      this.$store.state.priConfigrationforms.futureRisks.categories = [];

      if (configuration.negativeMedia.categories.length > 0) {
        configuration.futureRisks.categories.map((futureRisksData) => {
          this.editFutureRisksData.push(futureRisksData.settings);
        });
        this.editFutureRisksData.map((categoriesData) => {
          this.$store.state.priConfigrationforms.futureRisks.categories.push(
            categoriesData
          );
        });
      } else {
        this.priTypes.map(() => {
          this.setFutureRisksCategoriesValue();
        });
      }
    },
    showDuplicateModal(value) {
      this.editFutureRisksData = [];
      this.editNegativeMediaData = [];
      this.defaultIndicators = [];
      this.showAddPriModal = true;
      this.duplicatePri = true;
      this.selectedPriId = value.item.id;
      let configuration = JSON.parse(value.item.configuration);
      this.defaultIndicators = configuration.weighting
        ? configuration.weighting.defaultIndicators
        : configuration.overallWeighting.defaultIndicators;
      this.form = configuration;
      this.$store.state.priConfigrationforms.sanctions =
        configuration.sanctions;
      this.$store.state.priConfigrationforms.countryRules =
        configuration.countryRules;
      this.$store.state.priConfigrationforms.customIndicationsSettings =
        configuration.customIndicationsSettings;
      this.$store.state.priConfigrationforms.overallWeighting = configuration.weighting
        ? configuration.weighting
        : configuration.overallWeighting;
      this.$store.state.priConfigrationforms.openCorporate =
        configuration.openCorporate;
      this.$store.state.priConfigrationforms.publicListings =
        configuration.publicListings;
      this.negativeMediaEdit = true;
      this.$store.state.priConfigrationforms.negativeMedia.categories = [];
      this.$store.state.priConfigrationforms.negativeMedia.scoring = configuration
        .negativeMedia.scoring
        ? configuration.negativeMedia.scoring
        : this.$store.state.priConfigrationforms.negativeMedia.scoring;
      this.$store.state.priConfigrationforms.futureRisks.scoring = configuration
        .futureRisks.scoring
        ? configuration.futureRisks.scoring
        : this.$store.state.priConfigrationforms.futureRisks.scoring;

      if (configuration.negativeMedia.categories.length > 0) {
        configuration.negativeMedia.categories.map((negativeMediaData) => {
          this.editNegativeMediaData.push(negativeMediaData.settings);
        });
        this.editNegativeMediaData.map((categoriesData) => {
          if (categoriesData.scoring == undefined) {
            this.$store.state.priConfigrationforms.negativeMedia.categories.push(
              {
                customGoogleSearchEngineSites:
                  categoriesData.customGoogleSearchEngineSites,
                searchKeywords: categoriesData.searchKeywords,
                searchKeywordsNlp: categoriesData.searchKeywordsNlp,
                searchExcludeKeywords: categoriesData.searchExcludeKeywords,
                stopWords: categoriesData.stopWords,
                exactPhraseMatch: categoriesData.exactPhraseMatch,
                sortResult: categoriesData.sortResult,
                numberOfResults: categoriesData.numberOfResults,
                language: categoriesData.language,
                prePendSearchText: categoriesData.prePendSearchText,
                appendSearchText: categoriesData.appendSearchText,
                ignoreArticlesOlderThen: categoriesData.ignoreArticlesOlderThen,
                ignoreArticlesWithoutDates:
                  categoriesData.ignoreArticlesWithoutDates,
                ignoreArticlesFromLocalSites:
                  categoriesData.ignoreArticlesFromLocalSites,
                ignoreArticlesFromRegionalSites:
                  categoriesData.ignoreArticlesFromRegionalSites,
                ignoreArticlesFromGlobalSites:
                  categoriesData.ignoreArticlesFromGlobalSites,
                ignoreArticlesFromGlobalRegionalLocalSites:
                  categoriesData.ignoreArticlesFromGlobalRegionalLocalSites,
                disableRemovalText: categoriesData.disableRemovalText,
                scoring: {
                  weighting: {
                    lowerUpperLimit: categoriesData.lowerUpperLimit,
                    mediumUpperLimit: categoriesData.mediumUpperLimit,
                    ageOfArticleWeightingValue:
                      categoriesData.ageOfArticleValue,
                    siteTypeWeightingValue: categoriesData.siteTypeValue,
                    nlpMatchWeightingValue: categoriesData.nlpMatchValue,
                    keywordCountTotalWeightingValue:
                      categoriesData.keywordCountTotalValue,
                  },
                  ageOfArticleObject: {
                    ageOfArticle: categoriesData.ageOfArticle,
                    ageOfArticleToValue: categoriesData.ageOfArticleToValue,
                    ageOfArticleScoreValue:
                      categoriesData.ageOfArticleScoreValue,
                  },
                  siteTypeObject: {
                    siteType: categoriesData.siteType,
                    localSiteType: categoriesData.localSiteType,
                    regionalSiteType: categoriesData.regionalSiteType,
                    globalSiteType: categoriesData.globalSiteType,
                    unkownSiteType: categoriesData.unkownSiteType,
                  },
                  keywordCountObject: {
                    keywordCountTotal: categoriesData.keywordCountTotal,
                    lowerUpperLimit: categoriesData.matchKeywordCountValue,
                    mediumUpperLimit: 0,
                  },
                  nlpMatchObject: {
                    nlpMatch: categoriesData.nlpMatch,
                    matchNlpValue: categoriesData.matchNlpValue,
                  },
                },
              }
            );
          } else {
            this.$store.state.priConfigrationforms.negativeMedia.categories.push(
              categoriesData
            );
          }
        });
      } else {
        this.priTypes.map(() => {
          this.setNegativeMediaCategoriesValue();
        });
      }

      this.futureRisksEdit = true;
      this.$store.state.priConfigrationforms.futureRisks.categories = [];

      if (configuration.negativeMedia.categories.length > 0) {
        configuration.futureRisks.categories.map((futureRisksData) => {
          this.editFutureRisksData.push(futureRisksData.settings);
        });
        this.editFutureRisksData.map((categoriesData) => {
          this.$store.state.priConfigrationforms.futureRisks.categories.push(
            categoriesData
          );
        });
      } else {
        this.priTypes.map(() => {
          this.setFutureRisksCategoriesValue();
        });
      }
    },
    showEditModal(value) {
      this.editFutureRisksData = [];
      this.editNegativeMediaData = [];
      this.defaultIndicators = [];
      this.showAddPriModal = true;
      this.isEditPri = true;
      this.selectedPriId = value.item.id;
      let configuration = JSON.parse(value.item.configuration);
      this.defaultIndicators = configuration.weighting
        ? configuration.weighting.defaultIndicators
        : configuration.overallWeighting.defaultIndicators;
      this.form = configuration;
      this.$store.state.priConfigrationforms.sanctions =
        configuration.sanctions;
      this.$store.state.priConfigrationforms.countryRules =
        configuration.countryRules;
      this.$store.state.priConfigrationforms.customIndicationsSettings =
        configuration.customIndicationsSettings;
      this.$store.state.priConfigrationforms.overallWeighting = configuration.weighting
        ? configuration.weighting
        : configuration.overallWeighting;
      this.$store.state.priConfigrationforms.openCorporate =
        configuration.openCorporate;
      this.$store.state.priConfigrationforms.publicListings =
        configuration.publicListings;
      this.negativeMediaEdit = true;
      this.$store.state.priConfigrationforms.negativeMedia.categories = [];
      this.$store.state.priConfigrationforms.negativeMedia.scoring = configuration
        .negativeMedia.scoring
        ? configuration.negativeMedia.scoring
        : this.$store.state.priConfigrationforms.negativeMedia.scoring;
      this.$store.state.priConfigrationforms.futureRisks.scoring = configuration
        .futureRisks.scoring
        ? configuration.futureRisks.scoring
        : this.$store.state.priConfigrationforms.futureRisks.scoring;

      if (configuration.negativeMedia.categories.length > 0) {
        configuration.negativeMedia.categories.map((negativeMediaData) => {
          this.editNegativeMediaData.push(negativeMediaData.settings);
        });
        this.editNegativeMediaData.map((categoriesData) => {
          if (categoriesData.scoring == undefined) {
            this.$store.state.priConfigrationforms.negativeMedia.categories.push(
              {
                customGoogleSearchEngineSites:
                  categoriesData.customGoogleSearchEngineSites,
                searchKeywords: categoriesData.searchKeywords,
                searchKeywordsNlp: categoriesData.searchKeywordsNlp,
                searchExcludeKeywords: categoriesData.searchExcludeKeywords,
                stopWords: categoriesData.stopWords,
                exactPhraseMatch: categoriesData.exactPhraseMatch,
                sortResult: categoriesData.sortResult,
                numberOfResults: categoriesData.numberOfResults,
                language: categoriesData.language,
                prePendSearchText: categoriesData.prePendSearchText,
                appendSearchText: categoriesData.appendSearchText,
                ignoreArticlesOlderThen: categoriesData.ignoreArticlesOlderThen,
                ignoreArticlesWithoutDates:
                  categoriesData.ignoreArticlesWithoutDates,
                ignoreArticlesFromLocalSites:
                  categoriesData.ignoreArticlesFromLocalSites,
                ignoreArticlesFromRegionalSites:
                  categoriesData.ignoreArticlesFromRegionalSites,
                ignoreArticlesFromGlobalSites:
                  categoriesData.ignoreArticlesFromGlobalSites,
                ignoreArticlesFromGlobalRegionalLocalSites:
                  categoriesData.ignoreArticlesFromGlobalRegionalLocalSites,
                disableRemovalText: categoriesData.disableRemovalText,
                scoring: {
                  weighting: {
                    lowerUpperLimit: categoriesData.lowerUpperLimit,
                    mediumUpperLimit: categoriesData.mediumUpperLimit,
                    ageOfArticleWeightingValue:
                      categoriesData.ageOfArticleValue,
                    siteTypeWeightingValue: categoriesData.siteTypeValue,
                    nlpMatchWeightingValue: categoriesData.nlpMatchValue,
                    keywordCountTotalWeightingValue:
                      categoriesData.keywordCountTotalValue,
                  },
                  ageOfArticleObject: {
                    ageOfArticle: categoriesData.ageOfArticle,
                    ageOfArticleToValue: categoriesData.ageOfArticleToValue,
                    ageOfArticleScoreValue:
                      categoriesData.ageOfArticleScoreValue,
                  },
                  siteTypeObject: {
                    siteType: categoriesData.siteType,
                    localSiteType: categoriesData.localSiteType,
                    regionalSiteType: categoriesData.regionalSiteType,
                    globalSiteType: categoriesData.globalSiteType,
                    unkownSiteType: categoriesData.unkownSiteType,
                  },
                  keywordCountObject: {
                    keywordCountTotal: categoriesData.keywordCountTotal,
                    lowerUpperLimit: categoriesData.matchKeywordCountValue,
                    mediumUpperLimit: 0,
                  },
                  nlpMatchObject: {
                    nlpMatch: categoriesData.nlpMatch,
                    matchNlpValue: categoriesData.matchNlpValue,
                  },
                },
              }
            );
          } else {
            this.$store.state.priConfigrationforms.negativeMedia.categories.push(
              categoriesData
            );
          }
        });
      } else {
        this.priTypes.map(() => {
          this.setNegativeMediaCategoriesValue();
        });
      }

      this.futureRisksEdit = true;
      this.$store.state.priConfigrationforms.futureRisks.categories = [];

      if (configuration.negativeMedia.categories.length > 0) {
        configuration.futureRisks.categories.map((futureRisksData) => {
          this.editFutureRisksData.push(futureRisksData.settings);
        });
        this.editFutureRisksData.map((categoriesData) => {
          this.$store.state.priConfigrationforms.futureRisks.categories.push(
            categoriesData
          );
        });
      } else {
        this.priTypes.map(() => {
          this.setFutureRisksCategoriesValue();
        });
      }
    },
    showEditModalOnPriSimulationPage(value, id) {
      this.getClientPri();
      this.companyId = id;
      this.priSimulationPage = true;
      this.defaultIndicators = [];
      this.showAddPriModal = true;
      this.isEditPri = true;
      this.selectedPriId = value.id;
      let configuration = JSON.parse(value.configuration);
      this.defaultIndicators = configuration.weighting
        ? configuration.weighting.defaultIndicators
        : configuration.overallWeighting.defaultIndicators;
      this.form = configuration;
      this.$store.state.priConfigrationforms.sanctions =
        configuration.sanctions;
      this.$store.state.priConfigrationforms.countryRules =
        configuration.countryRules;
      this.$store.state.priConfigrationforms.openCorporate =
        configuration.openCorporate;
      this.$store.state.priConfigrationforms.publicListings =
        configuration.publicListings;
      this.$store.state.priConfigrationforms.customIndicationsSettings =
        configuration.customIndicationsSettings;
      this.$store.state.priConfigrationforms.weighting = configuration.weighting
        ? configuration.weighting
        : configuration.overallWeighting;
      this.negativeMediaEdit = true;
      this.$store.state.priConfigrationforms.negativeMedia.categories = [];

      if (configuration.negativeMedia.categories.length > 0) {
        configuration.negativeMedia.categories.map((negativeMediaData) => {
          this.editNegativeMediaData.push(negativeMediaData.settings);
        });
        this.editNegativeMediaData.map((categoriesData) => {
          this.$store.state.priConfigrationforms.negativeMedia.categories.push(
            categoriesData
          );
        });
      } else {
        this.priTypes.map(() => {
          this.setNegativeMediaCategoriesValue();
        });
      }

      this.futureRisksEdit = true;
      this.$store.state.priConfigrationforms.futureRisks.categories = [];

      if (configuration.futureRisks.categories.length > 0) {
        configuration.futureRisks.categories.map((futureRisksData) => {
          this.editFutureRisksData.push(futureRisksData.settings);
        });
        this.editFutureRisksData.map((categoriesData) => {
          this.$store.state.priConfigrationforms.futureRisks.categories.push(
            categoriesData
          );
        });
      } else {
        this.priTypes.map(() => {
          this.setFutureRisksCategoriesValue();
        });
      }
    },
    showAddModalOnPriSimulationPage(value) {
      this.getClientPri();
      this.priSimulationPage = true;
      this.showAddPriModal = true;
      this.isEditPri = false;
      this.companyId = value;
    },
    async getDueDiligenceCategoriesOptions() {
      this.dueDiligenceCategoriesOption = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/get-due-diligence-categories-options",
          null,
          {
            Authorization: token,
          }
        );
        this.dueDiligenceCategoriesOption = result.data.DueDiligenceCategories;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    async getClientCustomPriFields() {
      let token = "Bearer " + localStorage.getItem("accessToken");

      this.isLoadingPriData = true;
      try {
        let result = await HTTP(
          "get",
          "v1/pri/getclientcustomprifields/" + this.$route.params.id,
          null,
          {
            Authorization: token,
          },
          null,
          true
        );
        this.customIndicators = result.data.customFields;
        this.isLoadingPriData = false;
      } catch {
        this.isLoadingPriData = false;
      }
    },
    async getAllCustomPriFields() {
      let token = "Bearer " + localStorage.getItem("accessToken");

      this.isLoadingPriData = true;
      try {
        let result = await HTTP(
          "get",
          "v1/pri/getallclientcustomprifields",
          null,
          {
            Authorization: token,
          },
          null,
          true
        );
        this.customIndicators = result.data.customFields;
        this.isLoadingPriData = false;
      } catch {
        this.isLoadingPriData = false;
      }
    },
    checkValidation() {
      // if (this.form.showCountry) {
      //   this.$v.form.countryRules.$touch();
      //   if (this.$v.form.countryRules.$anyError) {
      //     return;
      //   }
      // }
      if (this.form.showNegativeMedia) {
        if (
          this.$store.state.priConfigrationforms.negativeMedia.searchKeywords ==
          []
        ) {
          alert("Atleast add one entity name you would like to search");
          return;
        }
      }
      this.$v.form.setup.$touch();
      if (this.$v.form.setup.$anyError) {
        return;
      } else if (this.isEditPri) {
        this.updatePri();
      } else {
        this.createPri();
      }
    },
    async updatePri() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let postData = {
        pri_version_id: this.selectedPriId,
        pri_category_id: 1,
        pri_title: this.form.setup.priTitle,
        configurationSettings: {
          ...this.form,
          sanctions: {
            ...this.$store.state.priConfigrationforms.sanctions,
          },
          countryRules: {
            ...this.$store.state.priConfigrationforms.countryRules,
          },
          negativeMedia: {
            scoring: {
              ...this.$store.state.priConfigrationforms.negativeMedia.scoring,
            },
            categories: this.form.setup.negativeMedia.selectedCategories.map(
              (categoriesTypes, index) => {
                return {
                  title: categoriesTypes.text,
                  id: categoriesTypes.value,
                  settings: this.$store.state.priConfigrationforms.negativeMedia
                    .categories[index],
                };
              }
            ),
          },
          futureRisks: {
            scoring: {
              ...this.$store.state.priConfigrationforms.futureRisks.scoring,
            },
            categories: this.form.setup.futureRisks.selectedCategories.map(
              (categoriesTypes, index) => {
                return {
                  title: categoriesTypes.text,
                  id: categoriesTypes.value,
                  settings: this.$store.state.priConfigrationforms.futureRisks
                    .categories[index],
                };
              }
            ),
          },
          customIndicationsSettings: {
            ...this.$store.state.priConfigrationforms.customIndicationsSettings,
          },
          overallWeighting: {
            ...this.$store.state.priConfigrationforms.overallWeighting,
            defaultIndicators: this.defaultIndicators,
            customIndicators: this.customIndicators,
          },
          openCorporate: {
            ...this.$store.state.priConfigrationforms.openCorporate,
          },
          publicListings: {
            ...this.$store.state.priConfigrationforms.publicListings,
          },
        },
        created_by_id: parseInt(localStorage.getItem("userId")),
        company_id: this.companyId
          ? this.platformPriSettings
            ? 0
            : this.companyId
          : this.platformPriSettings
          ? 0
          : parseInt(this.$route.params.id),
      };
      this.isLoadingPriData = true;
      this.priSubmiting = true;
      this.isLoading = true;
      try {
        await HTTP(
          "post",
          "v1/pri/update",
          postData,
          {
            Authorization: token,
          },
          null,
          true
        );

        this.priSubmiting = false;
        this.priResponseSuccess = true;
        this.isLoadingPriData = false;
      } catch {
        this.priSubmiting = false;
        this.isLoadingPriData = false;
        this.showErrorToast = true;
      } finally {
        if (this.priSimulationPage) {
          this.getPriList(this.companyId);
        } else {
          if (this.clientPriSettings) {
            this.getClientPri();
          } else {
            this.getAllPriData();
          }
        }
      }
    },
    async createPri() {
      let token = "Bearer " + localStorage.getItem("accessToken");

      let postData = {
        pri_category_id: 1,
        pri_title: this.form.setup.priTitle,
        configurationSettings: {
          ...this.form,
          sanctions: {
            ...this.$store.state.priConfigrationforms.sanctions,
          },
          countryRules: {
            ...this.$store.state.priConfigrationforms.countryRules,
          },
          negativeMedia: {
            scoring: {
              ...this.$store.state.priConfigrationforms.negativeMedia.scoring,
            },
            categories: this.form.setup.negativeMedia.selectedCategories.map(
              (categoriesTypes, index) => {
                return {
                  title: categoriesTypes.text,
                  id: categoriesTypes.value,
                  settings: this.$store.state.priConfigrationforms.negativeMedia
                    .categories[index],
                };
              }
            ),
          },
          futureRisks: {
            scoring: {
              ...this.$store.state.priConfigrationforms.futureRisks.scoring,
            },
            categories: this.form.setup.futureRisks.selectedCategories.map(
              (categoriesTypes, index) => {
                return {
                  title: categoriesTypes.text,
                  id: categoriesTypes.value,
                  settings: this.$store.state.priConfigrationforms.futureRisks
                    .categories[index],
                };
              }
            ),
          },
          customIndicationsSettings: {
            ...this.$store.state.priConfigrationforms.customIndicationsSettings,
          },
          overallWeighting: {
            ...this.$store.state.priConfigrationforms.overallWeighting,
            defaultIndicators: this.defaultIndicators,
            customIndicators: this.customIndicators,
          },
          openCorporate: {
            ...this.$store.state.priConfigrationforms.openCorporate,
          },
          publicListings: {
            ...this.$store.state.priConfigrationforms.publicListings,
          },
        },
        created_by_id: parseInt(localStorage.getItem("userId")),
        company_id: this.companyId
          ? this.platformPriSettings
            ? 0
            : this.companyId
          : this.platformPriSettings
          ? 0
          : parseInt(this.$route.params.id),
      };
      this.priSubmiting = true;
      this.isLoading = true;
      this.isLoadingPriData = true;
      try {
        await HTTP(
          "post",
          "v1/pri/create",
          postData,
          {
            Authorization: token,
          },
          null,
          true
        );

        this.priSubmiting = false;
        this.priResponseSuccess = true;
        this.isLoadingPriData = false;
      } catch {
        this.priSubmiting = false;
        this.isLoadingPriData = false;
        this.showErrorToast = true;
      } finally {
        if (this.priSimulationPage) {
          this.getPriList(this.companyId);
        } else {
          if (this.clientPriSettings) {
            this.getClientPri();
          } else {
            this.getAllPriData();
          }
        }
      }
    },

    resetForm() {
      this.isEditPri = false;
      this.duplicatePri = false;
      this.viewDisablePriModal = false;
      this.editNegativeMediaData = [];
      (this.$store.state.priConfigrationforms = {
        negativeMedia: {
          scoring: {
            weighting: {
              lowerUpperLimit: 30,
              mediumUpperLimit: 32,
              ageOfArticleWeightingValue: null,
              siteTypeWeightingValue: null,
              nlpMatchWeightingValue: null,
              keywordCountTotalWeightingValue: null,
            },
            ageOfArticleObject: {
              ageOfArticle: true,
              ageOfArticleToValue: [],
              ageOfArticleScoreValue: [],
            },
            siteTypeObject: {
              siteType: true,
              localSiteType: null,
              regionalSiteType: null,
              globalSiteType: null,
              unkownSiteType: null,
            },
            keywordCountObject: {
              keywordCountTotal: true,
              lowerUpperLimit: 30,
              mediumUpperLimit: 32,
            },
            nlpMatchObject: {
              nlpMatch: true,
              matchNlpValue: null,
            },
          },
          categories: [],
        },
        futureRisks: {
          scoring: {
            weighting: {
              lowerUpperLimit: 30,
              mediumUpperLimit: 32,
              ageOfArticleWeightingValue: null,
              siteTypeWeightingValue: null,
              nlpMatchWeightingValue: null,
              keywordCountTotalWeightingValue: null,
            },
            ageOfArticleObject: {
              ageOfArticle: true,
              ageOfArticleToValue: [],
              ageOfArticleScoreValue: [],
            },
            siteTypeObject: {
              siteType: true,
              localSiteType: null,
              regionalSiteType: null,
              globalSiteType: null,
              unkownSiteType: null,
            },
            keywordCountObject: {
              keywordCountTotal: true,
              lowerUpperLimit: 30,
              mediumUpperLimit: 32,
            },
            nlpMatchObject: {
              nlpMatch: true,
              matchNlpValue: null,
            },
          },
          categories: [],
        },
        sanctions: {
          isIDD: false,
          isIddPlus: false,
          indicatorIsHigh: false,
          indicatorIsOverallHigh: false,
          eventCategoryCodeSelected: null,
          eventSubCategoryCodeSelected: null,
          lowerUpperLimit: 30,
          mediumUpperLimit: 32,
          setMatchScores: null,
          CVIP: false,
          riskScore: false,
          textMatch: false,
          pepMatch: false,
          entityMatch: false,
          identifierMatch: false,
          CVIPCategoryValue: [],
          CVIPScoreValue: [],
          riskScoreCategoryValue: [2],
          riskScoreScoreValue: [],
          pepMatchInput: null,
          processScoreCategoryValue: [2],
          processScoreValue: [],
          similarTextCategoryScoreValue: [2],
          similarTextScoreValue: [],
          tokenSortCategoryScoreValue: [2],
          tokenSortScoreValue: [],
          tokenSortRatioCategoryScoreValue: [2],
          tokenSortRatioScoreValue: [],
          soundEx: null,
          identifiersItems: [],
          validInputField: false,
        },
        countryRules: {
          cpiIndex: false,
          activeSanctions: false,
          activeSanctionsScoring: null,
          lowerUpperLimit: 30,
          mediumUpperLimit: 32,
        },
        customIndicationsSettings: {
          customIndicatorsTabs: [],
        },
        overallWeighting: {
          defaultIndicators: [],
          customIndicators: [],
          lowerUpperLimit: 30,
          mediumUpperLimit: 75,
        },
        openCorporate: {
          companyNumber: false,
          partialSearch: false,
          globalSearch: false,
          stopWords: false,
          stopWordsList: [],
          veryRare: null,
          rare: null,
          common: null,
          veryCommon: null,
          disableRemovalText: false,
        },
        publicListings: {
          matchExact: false,
          matchPartial: false,
          matchSimilar: false,
          stopWords: false,
          stopWordsList: [],
          disableRemovalText: false,
        },
      }),
        (this.form = {
          pri_category_id: null,
          setup: {
            selectedPriType: null,
            negativeMedia: {
              selectedCategories: [],
            },
            futureRisks: {
              selectedCategories: [],
            },
          },
          rules: {},
          showSanctions: false,
          showNegativeMedia: false,
          showCountry: false,
          showIndustry: false,
          showCustomIndicators: false,
          status: 1, //1=draft
        });
      this.priTypes.map(() => {
        this.setNegativeMediaCategoriesValue();
        this.setFutureRisksCategoriesValue();
      });
      this.defaultIndicators = [];
      this.priResponseSuccess = false;
      this.priSubmiting = false;
      this.showAddPriModal = false;
      this.$v.$reset();
    },
    async getClientPri() {
      this.$store.state.isLoadingPriData = true;
      let token = "Bearer " + localStorage.getItem("accessToken");

      try {
        let result = await HTTP(
          "get",
          "v1/client-pri/all/" + parseInt(this.$route.params.id),
          null,
          {
            Authorization: token,
          },
          null,
          true
        );

        this.$store.state.clientAllPriItems = result.data.pri;
        this.getPriConfigrationData(result.data.pri);
        this.$store.state.isLoadingPriData = false;
      } catch {
        this.$store.state.isLoadingPriData = false;

        this.showErrorToast = true;
      }
    },
    async getAllPriData() {
      this.$store.state.isLoadingPriData = true;
      let token = "Bearer " + localStorage.getItem("accessToken");

      try {
        let result = await HTTP(
          "get",
          "v1/pri/all",
          null,
          {
            Authorization: token,
          },
          null,
          true
        );

        this.$store.state.allPriItems = result.data.pri;
        this.getPriConfigrationData(result.data.pri);
        this.$store.state.isLoadingPriData = false;
      } catch {
        this.$store.state.isLoadingPriData = false;
      }
    },
    getPriConfigrationData(data) {
      // console.log("getPriConfigrationData getPriConfigrationData", data);
      data.map((items) => {
        let configurationData = JSON.parse(items.configuration);
        // negative media
        configurationData.negativeMedia.categories.map((negativeMediaData) => {
          let searchKeywords = negativeMediaData.settings
            ? negativeMediaData.settings.searchKeywords
            : [];
          searchKeywords.map((searchKeywordsData) => {
            this.priConfigrationKeywordsData.push(searchKeywordsData);
          });
          let searchExcludeKeywords = negativeMediaData.settings
            ? negativeMediaData.settings.searchExcludeKeywords
            : [];
          searchExcludeKeywords.map((searchExcludeKeywordsData) => {
            this.priConfigrationExcludeKeywordsData.push(
              searchExcludeKeywordsData
            );
          });
          let stopWords = negativeMediaData.settings
            ? negativeMediaData.settings.stopWords
            : [];
          stopWords.map((stopWordsData) => {
            // console.log(
            //   "stopWordsData 1 stopWordsData 1 stopWordsData 1 stopWordsData 1",
            //   stopWordsData
            // );
            this.priConfigrationStopWordsData.push(stopWordsData);
          });
        });
        // future risks
        configurationData.futureRisks.categories.map((futureRisksData) => {
          let searchKeywords = futureRisksData.settings
            ? futureRisksData.settings.searchKeywords
            : [];
          searchKeywords.map((searchKeywordsData) => {
            this.priConfigrationKeywordsData.push(searchKeywordsData);
          });
          let searchExcludeKeywords = futureRisksData.settings
            ? futureRisksData.settings.searchExcludeKeywords
            : [];
          searchExcludeKeywords.map((searchExcludeKeywordsData) => {
            this.priConfigrationExcludeKeywordsData.push(
              searchExcludeKeywordsData
            );
          });
          let stopWords = futureRisksData.settings
            ? futureRisksData.settings.stopWords
            : [];
          stopWords.map((stopWordsData) => {
            // console.log(
            //   "stopWordsData 2 stopWordsData 2 stopWordsData 2 stopWordsData 2",
            //   stopWordsData
            // );
            this.priConfigrationStopWordsData.push(stopWordsData);
          });
        });
      });
    },

    async getPriList(id) {
      this.$store.state.clientAllPriOptions = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("get", "v1/getprilist/" + id, null, {
          Authorization: token,
        });
        if (this.clientId != null) {
          this.$store.state.clientAllPriOptions = result.data.pri;
        } else {
          this.$store.state.clientAllPriOptions = [];
        }
        let soundAlert = new Audio(
          "http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3"
        );
        soundAlert.play();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    setPriTitleValue(value) {
      if (value) {
        return "";
      } else {
        this.defaultIndicators = [];
        this.form.showSanctions = false;
        this.form.showNegativeMedia = false;
        this.form.showCountry = false;
        this.form.showIndustry = false;
        this.form.showCustomIndicators = false;
        this.form.showFutureRisks = false;
        this.form.showOpenCorporate = false;
        this.form.showPublicListing = false;
      }
    },
    setSanctionsWeightingsInput(value) {
      let data = {
        text: "Sanctions and enforcement ",
        value: 25,
        key: "sanctions",
      };
      if (value) {
        this.defaultIndicators.push(data);
      } else {
        let index = this.defaultIndicators.findIndex((x) => x.key == data.key);
        this.defaultIndicators.splice(index, 1);
      }
    },
    setNegativeMediasWeightingsInput(value) {
      let data = { text: "Negative Media", value: 50, key: "negative" };
      if (value) {
        this.defaultIndicators.push(data);
      } else {
        let index = this.defaultIndicators.findIndex((x) => x.key == data.key);
        this.defaultIndicators.splice(index, 1);
      }
    },
    setCountryWeightingsInput(value) {
      let data = { text: "Country", value: 25, key: "country" };
      if (value) {
        this.defaultIndicators.push(data);
      } else {
        let index = this.defaultIndicators.findIndex((x) => x.key == data.key);
        this.defaultIndicators.splice(index, 1);
      }
    },
    setIndustryWeightingsInput(value) {
      let data = { text: "Industry", value: 25, key: "industry" };
      if (value) {
        this.defaultIndicators.push(data);
      } else {
        let index = this.defaultIndicators.findIndex((x) => x.key == data.key);
        this.defaultIndicators.splice(index, 1);
      }
    },
  },
  props: {
    selectedPriData: Object,
    platformPriSettings: Boolean,
    clientPriSettings: Boolean,
  },
};
</script>
